import { render, staticRenderFns } from "./activitypackagedetails.vue?vue&type=template&id=f53d47c6&scoped=true"
import script from "./activitypackagedetails.vue?vue&type=script&lang=js"
export * from "./activitypackagedetails.vue?vue&type=script&lang=js"
import style0 from "./activitypackagedetails.vue?vue&type=style&index=0&id=f53d47c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53d47c6",
  null
  
)

export default component.exports